import React from "react";
import { Flex, Table, TableContainer, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import { BLUEMONEDDBUTTONS, WHITE } from "../../../../constants/colors";

export default function ExtractsList(){
    return (
        <Flex w={"100%"} justifyContent={"center"} px={10} mt="50px">
            <TableContainer borderRadius="8px" >
                <Table variant="striped" colorScheme='gray'  overflowY="scroll">
                    <Thead h="60px">
                        <Tr>
                            <Th w={"300px"} borderRadius={"0 0 0 8px"} textAlign={"center"} bgColor={BLUEMONEDDBUTTONS} color={WHITE}>
                                ID da Venda
                            </Th>
                            <Th w={"300px"} textAlign={"center"} bgColor={BLUEMONEDDBUTTONS} color={WHITE}>
                                Data da Venda
                            </Th>
                            <Th w={"300px"} textAlign={"center"} bgColor={BLUEMONEDDBUTTONS} color={WHITE}>
                                Status
                            </Th>
                            <Th w={"300px"} textAlign={"center"} bgColor={BLUEMONEDDBUTTONS} color={WHITE}>
                                Estabelecimento
                            </Th>
                            <Th w={"300px"} textAlign={"center"} bgColor={BLUEMONEDDBUTTONS} color={WHITE}>
                                Pagador
                            </Th>
                            <Th w={"300px"} textAlign={"center"} bgColor={BLUEMONEDDBUTTONS} color={WHITE}>
                                Tipo de Venda
                            </Th>
                            <Th w={"300px"} borderRadius={"0 0 8px 0"} textAlign={"center"} bgColor={BLUEMONEDDBUTTONS} color={WHITE}>
                                Valor
                            </Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        <Tr>
                            <Td borderRadius={"8px 0 0 8px"} textAlign={"center"}>teste</Td>
                            <Td textAlign={"center"}>teste</Td>
                            <Td textAlign={"center"}>teste</Td>
                            <Td textAlign={"center"}>teste</Td>
                            <Td textAlign={"center"}>teste</Td>
                            <Td textAlign={"center"}>teste</Td>
                            <Td borderRadius={"0 8px 8px 0"} textAlign={"center"}>teste</Td>
                        </Tr>
                        <Tr>
                            <Td borderRadius={"8px 0 0 8px"} textAlign={"center"}>teste</Td>
                            <Td textAlign={"center"}>teste</Td>
                            <Td textAlign={"center"}>teste</Td>
                            <Td textAlign={"center"}>teste</Td>
                            <Td textAlign={"center"}>teste</Td>
                            <Td textAlign={"center"}>teste</Td>
                            <Td borderRadius={"0 8px 8px 0"} textAlign={"center"}>teste</Td>
                        </Tr>
                    </Tbody>
                </Table>
            </TableContainer>
        </Flex>
    )
};